const Description = ({
  text,
  type = "string",
}: {
  text: string;
  type?: "string" | "html";
}) => {
  return (
    <div className="text text-[#3b3b3b]/70 leading-relaxed font-normal text-justify tracking-tighter hyphens-auto">
      {type === "html" ? (
        <p className="text-lg" dangerouslySetInnerHTML={{ __html: text }} />
      ) : (
        text
      )}
    </div>
  );
};

export default Description;
